import { Setting } from './gung-flow-details-product-settings.component';

const VALUE_SEPARATOR = ',';
const PATH_SEPARATOR = ' › ';

export function splitConditionValues(value: string | null | undefined): string[] {
  if (!value) {
    return [];
  }
  return value
    .split(VALUE_SEPARATOR)
    .map(v => v.trim())
    .filter(v => v.length > 0);
}

export function joinConditionValues(values: string[]): string | null {
  if (!values || values.length === 0) {
    return null;
  }
  return values.join(VALUE_SEPARATOR);
}

export function humanizeConditionPath(key: string[]): string {
  return key.join(PATH_SEPARATOR);
}

export function isEmptyConditionGroup(group: Setting[]): boolean {
  return !group.some(setting => !!setting.entry.value);
}
